export default __webpack_public_path__ + "static/media/img-data-base.6574678e.svg";